import validate from "validate.js";
import { Validator, presence, ValidationField, maxLength } from "~/extensions/utils";
import { commonStore } from "~/store/CommonStore";
export class AccountDetailValidator extends Validator {
    constructor(data) {
        const constraints = {
            password: {
                passwordFormatIfNotEmpty: {
                    pattern: /^([a-zA-Z0-9]{6,20})$/,
                    message: "新パスワードは大文字、小文字、数字のみで6文字以上20文字以内で入力してください。"
                }
            },
            email: {
                emailFormatIfNotEmpty: {
                    message: commonStore.messages.PV0013
                },
                length: maxLength(50)
            },
            smsNotificationType: {
                accountRegisterPresence: accountRegisterPresence(data, commonStore.messages.PV0002)
            },
            tel: {
                presence: presence(false, commonStore.messages.PV0001),
                telFormatAccount: telFormatAccount(data, commonStore.messages.PV0012, commonStore.messages.PV0022)
            }
        };
        super(data, constraints);
        this.password = new ValidationField("password", data, constraints);
        this.email = new ValidationField("email", data, constraints);
        this.smsNotificationType = new ValidationField("smsNotificationType", data, constraints);
        this.tel = new ValidationField("tel", data, constraints);
    }
    password;
    email;
    smsNotificationType;
    tel;
}
/** アカウント登録かつ契約区分が個人の場合にのみ必須チェック */
validate.validators.accountRegisterPresence = function (value, options, key, attributes) {
    if (!options.vm.isRegisteredAccount && options.vm.isKojin) {
        return validate.validators.presence(value, { allowEmpty: false, message: options.message }); // 組み込みのpresence
    }
    return null;
};
export function accountRegisterPresence(vm, message) {
    return {
        vm: vm,
        message: message
    };
}
/** アカウント更新の場合にのみ必須チェック */
validate.validators.accountUpdatePresence = function (value, options, key, attributes) {
    if (options.vm.isRegisteredAccount) {
        return validate.validators.presence(value, { allowEmpty: false, message: options.message }); // 組み込みのpresence
    }
    return null;
};
export function accountUpdatePresence(vm, message) {
    return {
        vm: vm,
        message: message
    };
}
/** メールアドレスのフォーマットチェック */
validate.validators.emailFormatIfNotEmpty = function (value, options) {
    if (value === null || value === "") {
        return "";
    }
    return validate.validators.email.call(validate.validators.email, value, options);
};
export function emailFormatIfNotEmpty(vm, message) {
    return {
        vm: vm,
        message: message
    };
}
validate.validators.passwordFormatIfNotEmpty = function (value, options) {
    if (value == null || value === "") {
        return null;
    }
    const pattern = options.pattern;
    if (!pattern.test(value)) {
        return options.message;
    }
    return null;
};
export function passwordFormatIfNotEmpty(vm, message) {
    return {
        vm: vm,
        message: message
    };
}
/** 電話番号バリデーション */
validate.validators.telFormatAccount = function (value, options, key, attributes) {
    // 個人の場合：携帯電話番号のみ受け付ける。060,070,080,090から始まる11桁
    if (options.vm.isKojin) {
        let pattern = new RegExp("^(060|070|080|090)-?\\d{4}-?\\d{4}$");
        return validate.validators.format(value, {
            pattern: pattern,
            message: options.message1
        });
    }
    if (options.vm.isHojin) {
        // 携帯電話 / IP電話 / 固定電話 ハイフン有の入力のみ受け付ける
        let pattern = new RegExp("^(?:(?:050|060|070|080|090)-\\d{4}-\\d{4}|(?!(?:050\\-|060\\-|070\\-|080\\-|090\\-))(?=.{12,16}$)(?:\\d+-){2,}\\d+)$");
        return validate.validators.format(value, {
            pattern: pattern,
            message: options.message2
        });
    }
    return null;
};
export function telFormatAccount(vm, message1, messaeg2) {
    return {
        vm: vm,
        message1: message1,
        message2: messaeg2
    };
}
